require('videogular');
require('./vg-buffering');

module.exports = 'com.2fdevs.videogular.plugins.buffering';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-buffering/index.js
// module id = 77
// module chunks = 0